<template>

    <body class="padding-top_xlarge">
        <div class="nav is-accent-primary">
            <div data-duration="400" data-animation="default" data-easing2="ease" data-easing="ease"
                data-collapse="medium" role="banner" data-no-scroll="1" class="nav_container w-nav">
                <div class="nav_left"><a href="#" class="nav_logo w-inline-block">
                        <div class="nav_logo-icon"></div>
                    </a></div>
                <div class="nav_right padding-right_small">
                    <div>Welcome, <strong>DJ &amp; Effects Sudbury</strong></div>
                </div>
                <div class="w-nav-overlay"></div>
            </div>
        </div>
        <div class="container position_relative" v-if="!requestIsSent">
            <div class="form w-form">
                <div class="grid_1-col padding_small gap-xsmall">
                    <div class="heading_h2">New Request</div>
                    <div>
                        <label for="field">Request Type</label>
                        <select v-model="requestType" class="input_field w-select">
                            <option value="">Select one...</option>
                            <option value="ad">New Ad Campaign</option>
                            <option value="logo">Logo Design</option>
                            <option value="website">Website Design</option>
                            <option value="card">Business Card Design</option>
                            <option value="Another option">Other</option>
                        </select>
                    </div>
                    <div>
                        <label for="title">Title</label>
                        <input class="input_field w-input" autofocus="true" maxlength="256"
                            placeholder="e.g. Summer Promo for Arcade" type="text" v-model="title">
                    </div>
                    <div>
                        <label for="desc">Description</label>
                        <textarea v-model="description" placeholder="Describe your ad, goals, size, deadlines, etc."
                            maxlength="5000" class="input_field w-input"></textarea>
                    </div>
                    <div>
                        <label for="email">E-Mail</label>
                        <input v-model="email" class="input_field w-input" autofocus="true" maxlength="256"
                            placeholder="you@domain.com" type="email" required="">
                    </div>
                    <div>
                        <label for="phone">Phone</label>
                        <input v-model="phone" class="input_field w-input" autofocus="true" maxlength="256"
                            placeholder="(000) 000-0000 " type="tel">
                    </div>
                    <div>
                        <label for="address">Address</label>
                        <input v-model="address" class="input_field w-input" autofocus="true" maxlength="256"
                            placeholder="123 Main St, City" type="text">
                    </div>
                    <div>
                        <label for="desc">Additional Information</label>
                        <textarea v-model="additionalInfo" placeholder="Colors, style, examples, etc..."
                            maxlength="5000" class="input_field w-input"></textarea>
                    </div>
                    <div class="grid_2-col gap-small">
                        <label for="file-upload" class="button is-secondary">
                            Upload Attachment
                        </label>
                        <input type="file" ref="fileInput" id="file-upload" @change="onFileChange"
                            style="display: none;">

                        <div class="paragraph flex-align-hor-middle-left height_100percent">{{ fileName }}</div>
                    </div>
                    <div class="button radius_medium" @click="sendRequest">Submit Request</div>
                    <p class="paragraph_medium text-align_left" style="color: salmon;">
                        {{ errorMessage }}
                    </p>
                    <div class="button radius_medium is-secondary" @click="exit">Exit</div>
                </div>
            </div>
        </div>
        <div class="container position_relative" v-if="requestIsSent">
            <div class="form w-form">
                <div class="grid_1-col padding_small gap-xsmall">
                    <div class="heading_h2 text-align_center">Your request is sent</div>
                    <div class="heading_h4 text-align_center">We will review your request and get in touch with you shortly.</div>
                    <div class="button radius_medium is-secondary" @click="$router.push('/portal')">Exit</div>

                </div>
            </div>
        </div>
        <ul role="list" data-w-id="ba12196d-23dc-a547-a94d-2fd3fa787625"
            class="grid_3-col gap-small position_relative padding_large w-list-unstyled">
            <li class="margin-bottom_none">
                <div class="is-large-1x1 margin-bottom_xsmall is-background"><svg xmlns="http://www.w3.org/2000/svg"
                        width="100%" height="100%" viewBox="0 0 24 24" fill="none">
                        <path d="M5.25 6.75H18.75V17.25H5.25V6.75Z" stroke="currentColor" stroke-width="1.5"
                            stroke-linejoin="round"></path>
                        <path d="M5.25 6.75L12 12L18.75 6.75" stroke="currentColor" stroke-width="1.5"
                            stroke-linejoin="round"></path>
                    </svg></div>
                <h5 class="heading_h5">Send an email</h5>
                <p class="text-color_secondary">Share your ideas or ask us anything.</p>
                <div><a href="#" class="text-link is-secondary">hello@leapdigitalmedia.ca</a></div>
            </li>
            <li class="margin-bottom_none">
                <div class="is-large-1x1 margin-bottom_xsmall is-background"><svg xmlns="http://www.w3.org/2000/svg"
                        width="100%" height="100%" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M12.5 18.25C16.2279 18.25 19.25 15.2279 19.25 11.5C19.25 7.77208 16.2279 4.75 12.5 4.75C8.77208 4.75 5.75 7.77208 5.75 11.5C5.75 12.6007 6.01345 13.6398 6.48072 14.5578L5 19L9.71819 17.6519C10.5664 18.0361 11.5082 18.25 12.5 18.25Z"
                            stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"></path>
                    </svg></div>
                <h4 class="heading_h5">Give us a call</h4>
                <p class="text-color_secondary">We’re here Mon–Fri, 8am–5pm PT.</p>
                <div>+1 (705) 220-2273<br></div>
            </li>
            <li class="margin-bottom_none">
                <div class="is-large-1x1 margin-bottom_xsmall is-background"><svg xmlns="http://www.w3.org/2000/svg"
                        width="100%" height="100%" viewBox="0 0 24 24" fill="none">
                        <path
                            d="M16.3918 14.8527C20.2489 10.9956 17.2769 4.25 12 4.25C6.72299 4.25 3.75102 10.9956 7.60817 14.8527L12 19.25L16.3918 14.8527Z"
                            stroke="currentColor" stroke-width="1.5" stroke-linejoin="round"></path>
                        <circle cx="12" cy="10.25" r="2" stroke="currentColor" stroke-width="1.5"></circle>
                    </svg></div>
                <h4 class="heading_h5">Stop by our office</h4>
                <p class="text-color_secondary">Visit us and meet our creative team.</p>
                <div>435 Notre Dame Ave,<br>Sudbury, ON, P3C 5K6<br>Canada</div>
            </li>
        </ul>
        <footer class="footer">
            <div class="container">
                <div class="w-layout-grid grid_5-col gap-small">
                    <div id="w-node-_851d61a1-1dad-400a-5b6a-92b99f998536-b17c3d94"
                        class="flex_vertical gap-small w-node-_586ae956-1ff0-8a55-6485-7937ed420a75-ed420a72"><a
                            href="#" class="logo w-inline-block">
                            <div class="nav_logo-icon"></div>
                        </a>
                        <ul role="list" aria-label="Social media links"
                            class="footer_icon-group margin_top-auto w-list-unstyled">
                            <li class="margin-bottom_none"><a href="#" class="footer_icon-link w-inline-block">
                                    <div class="icon_small-1x1 text-color_inherit"><svg width="100%" height="100%"
                                            viewBox="0 0 16 16">
                                            <path
                                                d="M16,8.048a8,8,0,1,0-9.25,7.9V10.36H4.719V8.048H6.75V6.285A2.822,2.822,0,0,1,9.771,3.173a12.2,12.2,0,0,1,1.791.156V5.3H10.554a1.155,1.155,0,0,0-1.3,1.25v1.5h2.219l-.355,2.312H9.25v5.591A8,8,0,0,0,16,8.048Z"
                                                fill="currentColor"></path>
                                        </svg></div>
                                    <div class="screen-reader">Follow us on Facebook</div>
                                </a></li>
                            <li class="margin-bottom_none"><a href="#" class="footer_icon-link w-inline-block">
                                    <div class="icon_small-1x1 text-color_inherit"><svg width="100%" height="100%"
                                            viewBox="0 0 16 16">
                                            <path
                                                d="M8,1.441c2.136,0,2.389.009,3.233.047a4.419,4.419,0,0,1,1.485.276,2.472,2.472,0,0,1,.92.6,2.472,2.472,0,0,1,.6.92,4.419,4.419,0,0,1,.276,1.485c.038.844.047,1.1.047,3.233s-.009,2.389-.047,3.233a4.419,4.419,0,0,1-.276,1.485,2.644,2.644,0,0,1-1.518,1.518,4.419,4.419,0,0,1-1.485.276c-.844.038-1.1.047-3.233.047s-2.389-.009-3.233-.047a4.419,4.419,0,0,1-1.485-.276,2.472,2.472,0,0,1-.92-.6,2.472,2.472,0,0,1-.6-.92,4.419,4.419,0,0,1-.276-1.485c-.038-.844-.047-1.1-.047-3.233s.009-2.389.047-3.233a4.419,4.419,0,0,1,.276-1.485,2.472,2.472,0,0,1,.6-.92,2.472,2.472,0,0,1,.92-.6,4.419,4.419,0,0,1,1.485-.276c.844-.038,1.1-.047,3.233-.047M8,0C5.827,0,5.555.009,4.7.048A5.868,5.868,0,0,0,2.76.42a3.908,3.908,0,0,0-1.417.923A3.908,3.908,0,0,0,.42,2.76,5.868,5.868,0,0,0,.048,4.7C.009,5.555,0,5.827,0,8s.009,2.445.048,3.3A5.868,5.868,0,0,0,.42,13.24a3.908,3.908,0,0,0,.923,1.417,3.908,3.908,0,0,0,1.417.923,5.868,5.868,0,0,0,1.942.372C5.555,15.991,5.827,16,8,16s2.445-.009,3.3-.048a5.868,5.868,0,0,0,1.942-.372,4.094,4.094,0,0,0,2.34-2.34,5.868,5.868,0,0,0,.372-1.942c.039-.853.048-1.125.048-3.3s-.009-2.445-.048-3.3A5.868,5.868,0,0,0,15.58,2.76a3.908,3.908,0,0,0-.923-1.417A3.908,3.908,0,0,0,13.24.42,5.868,5.868,0,0,0,11.3.048C10.445.009,10.173,0,8,0Z"
                                                fill="currentColor"></path>
                                            <path
                                                d="M8,3.892A4.108,4.108,0,1,0,12.108,8,4.108,4.108,0,0,0,8,3.892Zm0,6.775A2.667,2.667,0,1,1,10.667,8,2.667,2.667,0,0,1,8,10.667Z"
                                                fill="currentColor"></path>
                                            <circle cx="12.27" cy="3.73" r="0.96" fill="currentColor"></circle>
                                        </svg></div>
                                    <div class="screen-reader">See us on Instagram<br></div>
                                </a></li>
                            <li class="margin-bottom_none"><a href="#" class="footer_icon-link w-inline-block">
                                    <div class="icon_small-1x1 text-color_inherit"><svg width="100%" height="100%"
                                            viewBox="0 0 16 16">
                                            <path
                                                d="M12.3723 1.16992H14.6895L9.6272 6.95576L15.5825 14.829H10.9196L7.26734 10.0539L3.08837 14.829H0.769833L6.18442 8.64037L0.471436 1.16992H5.2528L8.55409 5.53451L12.3723 1.16992ZM11.5591 13.4421H12.843L4.55514 2.48399H3.17733L11.5591 13.4421Z"
                                                fill="currentColor"></path>
                                        </svg></div>
                                    <div class="screen-reader">Connect on X</div>
                                </a></li>
                            <li class="margin-bottom_none"><a href="#" class="footer_icon-link w-inline-block">
                                    <div class="icon_small-1x1 text-color_inherit"><svg width="100%" height="100%"
                                            viewBox="0 0 16 16">
                                            <path
                                                d="M15.3,0H0.7C0.3,0,0,0.3,0,0.7v14.7C0,15.7,0.3,16,0.7,16h14.7c0.4,0,0.7-0.3,0.7-0.7V0.7 C16,0.3,15.7,0,15.3,0z M4.7,13.6H2.4V6h2.4V13.6z M3.6,5C2.8,5,2.2,4.3,2.2,3.6c0-0.8,0.6-1.4,1.4-1.4c0.8,0,1.4,0.6,1.4,1.4 C4.9,4.3,4.3,5,3.6,5z M13.6,13.6h-2.4V9.9c0-0.9,0-2-1.2-2c-1.2,0-1.4,1-1.4,2v3.8H6.2V6h2.3v1h0c0.3-0.6,1.1-1.2,2.2-1.2 c2.4,0,2.8,1.6,2.8,3.6V13.6z"
                                                fill="currentColor"></path>
                                        </svg></div>
                                    <div class="screen-reader">Find us on LinkedIn</div>
                                </a></li>
                            <li class="margin-bottom_none"><a href="#" class="footer_icon-link w-inline-block">
                                    <div class="icon_small-1x1 text-color_inherit"><svg width="100%" height="100%"
                                            viewBox="0 0 16 16">
                                            <path
                                                d="M15.8,4.8c-0.2-1.3-0.8-2.2-2.2-2.4C11.4,2,8,2,8,2S4.6,2,2.4,2.4C1,2.6,0.3,3.5,0.2,4.8C0,6.1,0,8,0,8 s0,1.9,0.2,3.2c0.2,1.3,0.8,2.2,2.2,2.4C4.6,14,8,14,8,14s3.4,0,5.6-0.4c1.4-0.3,2-1.1,2.2-2.4C16,9.9,16,8,16,8S16,6.1,15.8,4.8z M6,11V5l5,3L6,11z"
                                                fill="currentColor"></path>
                                        </svg></div>
                                    <div class="screen-reader">Watch on YouTube</div>
                                </a></li>
                        </ul>
                    </div>
                    <ul role="list" id="w-node-_586ae956-1ff0-8a55-6485-7937ed420abb-ed420a72"
                        class="margin-bottom_none w-list-unstyled">
                        <li>
                            <h2 class="heading_h6 text-color_secondary">Company</h2>
                        </li>
                        <li><a href="#" class="footer_link w-inline-block">
                                <div>Pricing</div>
                            </a></li>
                        <li><a href="#" class="footer_link w-inline-block">
                                <div>Services</div>
                            </a></li>
                        <li><a href="#" class="footer_link w-inline-block">
                                <div>Contact</div>
                            </a></li>
                    </ul>
                    <ul role="list" id="w-node-_586ae956-1ff0-8a55-6485-7937ed420ad3-ed420a72"
                        class="margin-bottom_none w-list-unstyled">
                        <li>
                            <h2 class="heading_h6 text-color_secondary">Support</h2>
                        </li>
                        <li><a href="#" class="footer_link w-inline-block">
                                <div>FAQ</div>
                            </a></li>
                        <li><a href="#" class="footer_link w-inline-block">
                                <div>Terms</div>
                            </a></li>
                        <li><a href="#" class="footer_link w-inline-block">
                                <div>Privacy</div>
                            </a></li>
                    </ul>
                </div>
                <div class="divider margin-top_xsmall margin-bottom_xsmall"></div>
                <div class="footer_bottom">
                    <div class="text-color_secondary">© 2025 Leap Digital Media</div>
                </div>
            </div>
        </footer>
        <Loading v-if="isLoading" />
    </body>
</template>

<script>
import { mapState } from 'vuex';
import { auth, db, storage } from '@/firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, collection, addDoc} from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import Loading from '@/components/loading.vue';

export default {
    name: 'portal',
    data() {
        return {
            emailVerified: false,
            isLoading: false,
            // Form fields
            requestType: '',
            title: '',
            description: '',
            email: '',
            phone: '',
            address: '',
            additionalInfo: '',
            file: null,
            fileName: 'No file selected',
            errorMessage: '',
            requestIsSent: false,
        }
    },
    components: {
        Loading,
    },
    async mounted() {

        // Check if user is already logged in
        onAuthStateChanged(auth, async (user) => {
            if (user) {

                if (user.emailVerified) {
                    this.emailVerified = true;
                    // Set initial form values from auth user data

                } else {
                    this.emailVerified = false;
                    window.scrollTo(0, 0);
                    this.$router.push('/portal');
                }
            } else {
                this.$router.push('/'); // Redirect to home if user is not signed in
                console.log("No user is signed in.");
            }
        });

    },
    computed: {
        ...mapState(['user', 'isAuthenticated', 'userData']),
    },
    methods: {
        exit() {
            this.$router.push('/portal');
            window.scrollTo(0, 0);
        },
        onFileChange(event) {
            const file = event.target.files[0];
            if (file) {
                this.file = file;
                this.fileName = file.name;
            } else {
                this.file = null;
                this.fileName = 'No file selected';
            }
        },
        async sendRequest() {
            this.errorMessage = '';
            // make sure required fields are present (request type, title, description)
            if (!this.requestType || !this.title || !this.description) {
                this.errorMessage = 'Please fill in all required fields.';
                return;
            }
            this.isLoading = true;
            const user = auth.currentUser;

            if (!user) {
                this.errorMessage = 'You must be logged in to submit a request.';
                this.isLoading = false;
                return;
            }

            try {
                let fileUrl = null;
                if (this.file) {
                    const filePath = `assets/${user.uid}/${this.file.name}`;
                    const storageRef = ref(storage, filePath);
                    const uploadTask = await uploadBytes(storageRef, this.file);
                    fileUrl = await getDownloadURL(uploadTask.ref);
                }

                const newRequest = {
                    userId: user.uid,
                    requestType: this.requestType,
                    title: this.title,
                    description: this.description,
                    email: this.email,
                    phone: this.phone,
                    address: this.address,
                    additionalInformation: this.additionalInfo,
                    attachmentUrl: fileUrl, // The download URL from Firebase Storage
                    status: 'Pending',
                    createdAt: new Date(),
                };

                // Reference the subcollection 'requests' under the user's document
                const userDocRef = doc(db, 'users', user.uid);
                const requestsColRef = collection(userDocRef, 'requests');

                await addDoc(requestsColRef, newRequest);

                console.log("Request created successfully in user's subcollection!");
                this.isLoading = false;
                this.requestIsSent = true; // Set flag to show success message
                // Optionally, reset form fields or show a success message
            } catch (error) {
                console.error("Error submitting request:", error);
                this.errorMessage = 'Failed to submit request. Please try again.';
                this.isLoading = false;
            }
        },
    },
}
</script>